var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("UIButton", {
    attrs: {
      buttonText: _vm.buttonText,
      variant: _vm.buttonVariant,
      size: _vm.buttonSize,
      processing: _vm.processing,
      buttonClasses: _vm.buttonClasses,
      fullWidth: _vm.fullWidth,
    },
    on: { click: _vm.add },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }